import React from "react";
import PropTypes from "prop-types";
import { Form, List } from "semantic-ui-react";
import { strings } from "../../resources";
import {
  SignatureFieldContainer,
  DoctorSignatureContainer,
} from "../../../Images/containers";
import { DatePicker } from "../ui";
import { dateEpochToDateTimeString } from "../../../App/helpers/DateTimeFormatConversion";

const sections = [
  {
    header: strings.form.consentWording.ProfoundWhatIsHeader,
    content: strings.form.consentWording.ProfoundWhatIsContent,
  },
  {
    header: strings.form.consentWording.ProfoundNumberHeader,
    content: strings.form.consentWording.ProfoundNumberContent,
  },
  {
    header: strings.form.consentWording.ProfoundPainfulHeader,
    content: strings.form.consentWording.ProfoundPainfulContent,
  },
  {
    header: strings.form.consentWording.ProfoundPostTreatmentHeader,
    content: strings.form.consentWording.ProfoundPostTreatmentContent,
  },
  {
    header: strings.form.consentWording.ProfoundWorkHeader,
    content: strings.form.consentWording.ProfoundWorkContent,
  },
  {
    header: strings.form.consentWording.ProfoundResultsHeader,
    content: strings.form.consentWording.ProfoundResultsContent,
  },
  {
    header: strings.form.consentWording.ProfoundDissatisfiedHeader,
    content: strings.form.consentWording.ProfoundDissatisfiedContent,
  },
  {
    header: strings.form.consentWording.ProfoundOptimiseHeader,
    content: strings.form.consentWording.ProfoundOptimiseContent,
  },
  {
    header: strings.form.consentWording.ProfoundSideEffectsHeader,
    content: strings.form.consentWording.ProfoundSideEffectsContent,
  },
  {
    header: strings.form.consentWording.ProfoundConcernsHeader,
    content: strings.form.consentWording.ProfoundConcernsContent,
  },
];

class FormConsentProfound extends React.Component {
  componentWillMount = () => {
    if (this.props.mode === "create" || this.props.mode === "edit") {
      let todaysDateStr = dateEpochToDateTimeString(new Date(), "-");
      this.props.updateSelectedForm("date_patient_signed", todaysDateStr);
    }
  };

  render = () => {
    const errorFields = this.props.validationErrors.map((error) => {
      return error.field;
    });
    return (
      <div className="createFormContainer">
        <div className="patientFormSectionHeader">
          {strings.form.header.consentProfound}
        </div>
        <div className="personalInformation">
          <List relaxed>
            {sections.map((section) => (
              <List.Item key={section.header}>
                <List.Header>{section.header}</List.Header>
                {section.content}
              </List.Item>
            ))}
          </List>
          <Form.Group>
            <Form.Field
              className="textField"
              content={strings.form.consentWording.ProfoundClosing}
            />
          </Form.Group>
          <Form.Group>
            <Form.Input
              label={strings.form.label.patientPrintName}
              error={errorFields.includes("signed_by_patient")}
              name="signed_by_patient"
              onChange={this.props.handleChange}
              placeholder={strings.form.placeholder.patientPrintName}
              required
              value={this.props.selectedFormData.signed_by_patient || ""}
              width={8}
            />
          </Form.Group>
          <SignatureFieldContainer
            mode={this.props.mode}
            headers={this.props.headers}
            error={errorFields.includes("signature_data_url")}
            readOnly={this.props.mode === "create" ? false : true}
            signatureImagePath={
              this.props.formId ? `signatures/forms/${this.props.formId}` : ""
            }
          />
          <Form.Group>
            <DatePicker
              error={errorFields.includes("date_patient_signed")}
              className="datePatientSigned"
              name="date_patient_signed"
              onChange={this.props.handleDateChange}
              onKeyDown={(e) => this.props.handleDateKeyDown(e)}
              required
              label={strings.form.label.datePatientSigned}
              value={this.props.selectedFormData.date_patient_signed || ""}
            />
          </Form.Group>
          {(this.props.selectedFormData.doctor_signature_path ||
            this.props.mode === "template") && (
            <Form.Group>
              <DoctorSignatureContainer
                containerWidth={240}
                containerHeight={150}
                dateDoctorSigned={this.props.dateDoctorSigned}
                doctorName={this.props.doctorName}
                formId={this.props.formId}
                headers={this.props.headers}
                signaturePathAttachedToForm={
                  this.props.selectedFormData.doctor_signature_path
                }
              />
            </Form.Group>
          )}
        </div>
      </div>
    );
  };
}

FormConsentProfound.propTypes = {
  mode: PropTypes.string.isRequired, //create, view or edit
  selectedFormData: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
};

export default FormConsentProfound;
